'use client'

import * as React from 'react'
import { clsx } from 'clsx'

import { useFloatingBubblesAnimation } from '../../hooks/use-floating-bubbles-animation'
import { BluredBubble } from './blurred-bubble'
import { LogoColoredSvg } from './logo-colored-svg'
import { useTheme } from 'next-themes'

export const BlurredLogo = React.forwardRef<
  HTMLDivElement,
  { className?: string }
>(({ className, ...rest }, ref) => {
  const { setTarget } = useFloatingBubblesAnimation()
  const clipId = React.useId()
  const strokeId = React.useId()
  const mode = useTheme().resolvedTheme ?? 'dark'

  return (
    <div
      {...rest}
      ref={ref}
      className={clsx(
        'relative h-[100px] w-[100px] rounded-[20px] border border-dark-border bg-dark-base',
        className
      )}
      style={{
        WebkitMaskImage: '-webkit-radial-gradient(white, black)',
      }}
    >
      <LogoColoredSvg
        className="absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2"
        clipId={clipId}
        strokeId={strokeId}
        mode={mode as 'dark' | 'light'}
      />
      <div
        className="absolute top-1/2 left-1/2 z-30 -translate-x-1/2 -translate-y-1/2 overflow-hidden opacity-50"
        ref={(el) => {
          setTarget(el?.children ?? null)
        }}
        style={{
          // match LogoColoredSvg
          width: 48,
          height: 62,
          WebkitMaskImage: '-webkit-radial-gradient(white, black)',

          clipPath: `url(#${clipId})`,
        }}
      >
        <BluredBubble
          size={43}
          blur={15}
          className="absolute top-5 right-0 opacity-0"
        />
      </div>
    </div>
  )
})
